import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Переводы встроены прямо в код
const uzTranslation = {
  "header": {
    "title": "Avto Tarix",
    "home": "Bosh sahifa",
    "add": "Qo'shish",
    "search": "Qidirish",
    "admin": "Admin"
  },
  "home": {
    "title": "Avtomobil tarixi",
    "subtitle": "Avtomobillarning buzilish tarixini yaratish uchun foto va videolarni yuklang",
    "heroHeadline": "Avval tekshiring. Keyin xarid qiling.",
    "heroLead": "Davlat raqami bo'yicha avtomobilning ochiq tarixini ko'ring — DTP va boshqa hodisalar haqida yozuvlar.",
    "archiveNote": "Moderatsiyadan o'tgan yozuvlar",
    "views": "Ko'rishlar",
    "addCar": "Yozuv qo'shish",
    "searchCar": "Raqam bo'yicha qidirish",
    "recentCars": "Arxiv",
    "noCars": "Hozircha yozuvlar yo'q",
    "noCarsDescription": "Birinchi yozuvni qo'shing — moderatsiyadan keyin u arxivda paydo bo'ladi.",
    "viewDetails": "Ochish",
    "dateAdded": "Qo'shilgan sana",
    "ageRestriction": "18+ cheklov",
    "ageWarning": "Bu xizmat 18 yoshdan kichik shaxslar uchun taqiqlangan",
    "ageDisclaimer": "Materiallar o'lim, jarohatlar va boshqa og'ir kontentni o'z ichiga olishi mumkin",
    "serviceDescription": "Bu xizmat sizga ikkinchi qo'l avtomobil sotib olishda aldovlarga yo'l qo'ymaslik uchun mo'ljallangan. Sotib olishni rejalashtirgan avtomobilning davlat raqamini kiriting va uning avvalgi DTP yoki boshqa yo'l-transport hodisalarida ishtirok etganligini tekshirib ko'ring. Agar ma'lumotlar mavjud bo'lsa — avtomobilni sotib olish haqida qayta o'ylab ko'ring.\n\nAgar hech qanday ma'lumot topilmasa, avtomobil tarixi haqidagi rasmiy ma'lumotlarni olish uchun",
    "serviceDescriptionLink": "ЕПИГУ",
    "serviceDescriptionEnd": "portaliga murojaat qiling."
  },
  "ageRestriction": {
    "title": "Yosh cheklovi",
    "warning": "Diqqat! Bu materiallar 18 yoshdan kichik shaxslar uchun taqiqlangan.",
    "disclaimer": "Bu yozuvdagi foto va videolar o'lim, jarohatlar, qon va boshqa og'ir kontentni o'z ichiga olishi mumkin. Ular ba'zi odamlarga psixologik ta'sir ko'rsatishi mumkin.",
    "noLiability": "Avto Tarix.uz kontentning to'g'riligi, dolzarbligi yoki oqibatlari uchun javobgar emas. Barcha materiallar foydalanuvchilar tomonidan yuklangan. Ko'rish faqat o'z xavf-xataringiz ostida amalga oshiriladi.",
    "confirmAge": "Men 18 yoshdan katta ekanligimni tasdiqlayman",
    "agreement": "«Davom etish» tugmasini bosish orqali siz 18+ yoshda ekanligingizni, kontentni ko'rishga roziligingizni va xizmat hech qanday javobgarlikni o'z zimmasiga olmasligini to'liq qabul qilganingizni tasdiqlaysiz.",
    "enter": "Davom etish",
    "cancel": "Bekor qilish",
    "responsibility": "Men o'zim javobgar ekanligimni va xizmat javobgar emasligini tushunaman",
    "unlockMedia": "Foto va videolarni ko'rish uchun yoshni tasdiqlang va shartlarga rozilik bildiring."
  },
  "addCar": {
    "title": "Avtomobil qo'shish",
    "subtitle": "Tarix yaratish uchun buzilgan avtomobil haqida ma'lumot qo'shing",
    "licensePlate": "Avtomobil davlat raqami *",
    "licensePlatePlaceholder": "Masalan: 01A123AA",
    "location": "Joylashuv",
    "locationPlaceholder": "Masalan: Toshkent shahar",
    "photos": "Fotosuratlar",
    "dragPhotos": "Fotosuratlarni bu yerga torting",
    "photoFormats": "JPG, PNG (maksimal 5MB)",
    "videos": "Videolar",
    "dragVideos": "Videolarni bu yerga torting",
    "videoFormats": "MP4, AVI (maksimal 10MB)",
    "description": "Tavsif (ixtiyoriy)",
    "descriptionPlaceholder": "Buzilish haqida qo'shimcha ma'lumot...",
    "uploadMedia": "Media fayllarni yuklang",
    "uploadText": "Fayllarni bu yerga torting yoki tanlang",
    "uploadSubtext": "JPG, PNG, MP4, AVI (maksimal 10MB)",
    "submit": "Yuborish",
    "submitting": "Yuborilmoqda...",
    "success": "Avtomobil muvaffaqiyatli qo'shildi! Moderatsiya uchun yuborildi.",
    "error": "Xatolik yuz berdi. Iltimos, qayta urinib ko'ring.",
    "saveRecord": "Saqlash",
    "cancel": "Bekor qilish"
  },
  "searchCar": {
    "title": "Davlat raqami bo'yicha qidirish",
    "subtitle": "Avtomobil raqamini kiriting va yozuvlarni toping",
    "description": "Avtomobil sotib olishdan oldin tarixini tekshiring. DTP va buzilishlar haqida ma'lumot olish uchun davlat raqamini kiriting.",
    "licensePlate": "Avtomobil davlat raqami",
    "placeholder": "Masalan: 01A123AA",
    "search": "Qidirish",
    "searching": "Qidirilmoqda...",
    "noResults": "Bu raqam bo'yicha yozuvlar topilmadi",
    "noResultsDescription": "Qidiruv so'rovini o'zgartiring yoki raqam yozilishini to'g'riligini tekshiring",
    "resultsFound": "Natijalar topildi",
    "viewDetails": "Batafsil ko'rish",
    "dateAdded": "Qo'shilgan sana"
  },
  "carDetails": {
    "title": "Avtomobil tafsilotlari",
    "licensePlate": "Davlat raqami",
    "description": "Tavsif",
    "dateAdded": "Qo'shilgan sana",
    "status": "Holat",
    "approved": "Tasdiqlangan",
    "pending": "Kutilmoqda",
    "rejected": "Rad etilgan",
    "media": "Media fayllar",
    "photos": "Fotosuratlar",
    "videos": "Videolar",
    "back": "Orqaga",
    "backToSearch": "Qidiruvga qaytish",
    "noDescription": "Tavsif kiritilmagan",
    "notFound": "Yozuv topilmadi",
    "noMedia": "Media fayllar yo'q"
  },
  "login": {
    "title": "Tizimga kirish",
    "subtitle": "Ma'muriy panelga kirish uchun ma'lumotlaringizni kiriting",
    "username": "Foydalanuvchi nomi",
    "usernamePlaceholder": "Foydalanuvchi nomini kiriting",
    "password": "Parol",
    "passwordPlaceholder": "Parolni kiriting",
    "login": "Kirish",
    "logging": "Kiritilmoqda...",
    "error": "Noto'g'ri foydalanuvchi nomi yoki parol",
    "success": "Muvaffaqiyatli kiritildi!",
    "adminOnly": "Faqat vakolatli administratorlar uchun"
  },
  "admin": {
    "title": "Ma'muriy panel",
    "welcome": "Xush kelibsiz",
    "logout": "Chiqish",
    "pendingApprovals": "Tasdiqlash kutilmoqda",
    "approvedCars": "Tasdiqlangan avtomobillar",
    "rejectedCars": "Rad etilgan avtomobillar",
    "approve": "Tasdiqlash",
    "reject": "Rad etish",
    "viewDetails": "Batafsil ko'rish",
    "noPending": "Tasdiqlash kutilayotgan avtomobillar yo'q",
    "noApproved": "Tasdiqlangan avtomobillar yo'q",
    "noRejected": "Rad etilgan avtomobillar yo'q",
    "actions": "Amallar",
    "status": "Holat",
    "dateAdded": "Qo'shilgan sana"
  },
  "footer": {
    "aboutTitle": "Bizning xizmat haqida",
    "aboutText": "<strong>Avto-Tarix.uz</strong> — avtomobillar tarixini tekshirish uchun ishonchli xizmat. Biz xaridorlarga ishlatilgan avtomobillarni sotib olishda aldanishdan qochishga yordam beramiz, DTP va buzilishlar haqida ma'lumot beramiz.",
    "stats": "{{count}} ta tekshirilgan avtomobil",
    "viewsStats": "{{count}} ta ko'rish",
    "viewsHint": "Barcha kartochkalar bo'yicha umumiy ko'rishlar (reklama uchun)",
    "workingHours": "24/7 ishlaymiz",
    "followTitle": "Bizni kuzatib boring",
    "followText": "Yangilanishlar, foydali maslahatlar va yangi tekshiruvlar haqida xabardor bo'lish uchun Telegram kanalimizga obuna bo'ling.",
    "subscribeButton": "Kanalga obuna bo'lish",
    "importantTitle": "⚠️ Muhim ma'lumot",
    "importantText": "Biz taqdim etilgan ma'lumotlarning to'g'riligi va dolzarbligi uchun javobgar emasmiz. Barcha ma'lumotlar internetdagi ochiq manbalardan olingan va noto'g'riliklar bo'lishi mumkin. Avtomobil sotib olish haqida qaror qabul qilishda rasmiy manbalar orqali qo'shimcha tekshirish va texnik ekspertiza o'tkazishni tavsiya qilamiz.",
    "copyright": "© 2025 Avto-Tarix.uz | Avtomobillar tarixini tekshirish uchun axborot xizmati"
  },
  "common": {
    "loading": "Yuklanmoqda...",
    "error": "Xatolik yuz berdi",
    "success": "Muvaffaqiyatli",
    "cancel": "Bekor qilish",
    "save": "Saqlash",
    "delete": "O'chirish",
    "edit": "Tahrirlash",
    "close": "Yopish",
    "yes": "Ha",
    "no": "Yo'q",
    "confirm": "Tasdiqlash"
  }
};

const ruTranslation = {
  "header": {
    "title": "Авто История",
    "home": "Главная",
    "add": "Добавить",
    "search": "Поиск",
    "admin": "Админ"
  },
  "home": {
    "title": "История автомобиля",
    "subtitle": "Загружайте фото и видео поврежденных автомобилей для создания истории",
    "heroHeadline": "Сначала проверьте. Потом покупайте.",
    "heroLead": "Открытая история автомобиля по госномеру — записи о ДТП и других происшествиях.",
    "archiveNote": "Записи после модерации",
    "views": "Просмотры",
    "addCar": "Добавить запись",
    "searchCar": "Поиск по номеру",
    "recentCars": "Архив",
    "noCars": "Пока нет записей",
    "noCarsDescription": "Добавьте первую запись — после модерации она появится в архиве.",
    "viewDetails": "Открыть",
    "dateAdded": "Дата добавления",
    "ageRestriction": "Ограничение 18+",
    "ageWarning": "Данный сервис запрещен для лиц младше 18 лет",
    "ageDisclaimer": "Материалы могут содержать смерть, травмы и другой тяжелый контент",
    "serviceDescription": "Этот сервис создан для того, чтобы помочь вам избежать неприятных сюрпризов при покупке подержанного автомобиля. Введите государственный номер машины, которую вы планируете приобрести, чтобы проверить, не была ли она участником ДТП. Если информация о происшествиях будет найдена — это повод задуматься, стоит ли покупать автомобиль с такой историей.\n\nЕсли данных о ДТП нет, не забудьте дополнительно обратиться к официальному порталу",
    "serviceDescriptionLink": "ЕПИГУ",
    "serviceDescriptionEnd": "для получения официальной справки и убедиться в чистоте истории выбранного вами авто."
  },
  "ageRestriction": {
    "title": "Возрастное ограничение",
    "warning": "Внимание! Эти материалы запрещены для лиц младше 18 лет.",
    "disclaimer": "Фото и видео в записи могут содержать смерть, травмы, кровь и другой тяжёлый контент. Они могут оказать психологическое воздействие.",
    "noLiability": "Avto Tarix.uz не несёт ответственности за достоверность, актуальность или последствия просмотра контента. Все материалы загружены пользователями. Просмотр осуществляется на ваш собственный риск.",
    "confirmAge": "Я подтверждаю, что мне исполнилось 18 лет",
    "agreement": "Нажимая «Продолжить», вы подтверждаете, что вам 18+, вы согласны просматривать контент и полностью принимаете, что сервис не несёт никакой ответственности.",
    "enter": "Продолжить",
    "cancel": "Отмена",
    "responsibility": "Я понимаю, что несу ответственность сам и сервис не несет ответственности",
    "unlockMedia": "Чтобы открыть фото и видео, подтвердите возраст и согласие с условиями."
  },
  "addCar": {
    "title": "Добавить запись об автомобиле",
    "subtitle": "Добавьте информацию о поврежденном автомобиле для создания истории",
    "licensePlate": "Гос номер автомобиля *",
    "licensePlatePlaceholder": "Например: 01A123AA",
    "location": "Местоположение",
    "locationPlaceholder": "Например: г. Ташкент",
    "photos": "Фотографии",
    "dragPhotos": "Перетащите фотографии сюда",
    "photoFormats": "JPG, PNG (максимум 5MB)",
    "videos": "Видео",
    "dragVideos": "Перетащите видео сюда",
    "videoFormats": "MP4, AVI (максимум 10MB)",
    "description": "Описание (необязательно)",
    "descriptionPlaceholder": "Дополнительная информация о повреждении...",
    "uploadMedia": "Загрузите медиа файлы",
    "uploadText": "Перетащите файлы сюда или выберите",
    "uploadSubtext": "JPG, PNG, MP4, AVI (максимум 10MB)",
    "submit": "Отправить",
    "submitting": "Отправляется...",
    "success": "Автомобиль успешно добавлен! Отправлено на модерацию.",
    "error": "Произошла ошибка. Пожалуйста, попробуйте еще раз.",
    "saveRecord": "Сохранить",
    "cancel": "Отмена"
  },
  "searchCar": {
    "title": "Поиск по гос номеру",
    "subtitle": "Введите номер автомобиля для поиска записей",
    "description": "Проверьте историю автомобиля перед покупкой. Введите гос номер для поиска информации о ДТП и повреждениях.",
    "licensePlate": "Гос номер автомобиля",
    "placeholder": "Например: 01A123AA",
    "search": "Найти",
    "searching": "Поиск...",
    "noResults": "По данному номеру записи не найдены",
    "noResultsDescription": "Попробуйте изменить поисковый запрос или проверьте правильность написания номера",
    "resultsFound": "Найдено результатов",
    "viewDetails": "Подробнее",
    "dateAdded": "Дата добавления"
  },
  "carDetails": {
    "title": "Детали автомобиля",
    "licensePlate": "Гос номер",
    "description": "Описание",
    "dateAdded": "Дата добавления",
    "status": "Статус",
    "approved": "Одобрено",
    "pending": "На рассмотрении",
    "rejected": "Отклонено",
    "media": "Медиа файлы",
    "photos": "Фотографии",
    "videos": "Видео",
    "back": "Назад",
    "backToSearch": "Вернуться к поиску",
    "noDescription": "Описание не указано",
    "notFound": "Запись не найдена",
    "noMedia": "Нет медиафайлов"
  },
  "login": {
    "title": "Вход в систему",
    "subtitle": "Введите свои данные для входа в административную панель",
    "username": "Имя пользователя",
    "usernamePlaceholder": "Введите имя пользователя",
    "password": "Пароль",
    "passwordPlaceholder": "Введите пароль",
    "login": "Войти",
    "logging": "Вход...",
    "error": "Неверное имя пользователя или пароль",
    "success": "Успешный вход!",
    "adminOnly": "Только для авторизованных администраторов"
  },
  "admin": {
    "title": "Административная панель",
    "welcome": "Добро пожаловать",
    "logout": "Выйти",
    "pendingApprovals": "Ожидают одобрения",
    "approvedCars": "Одобренные автомобили",
    "rejectedCars": "Отклоненные автомобили",
    "approve": "Одобрить",
    "reject": "Отклонить",
    "viewDetails": "Подробнее",
    "noPending": "Нет автомобилей, ожидающих одобрения",
    "noApproved": "Нет одобренных автомобилей",
    "noRejected": "Нет отклоненных автомобилей",
    "actions": "Действия",
    "status": "Статус",
    "dateAdded": "Дата добавления"
  },
  "footer": {
    "aboutTitle": "О нашем сервисе",
    "aboutText": "<strong>Avto-Tarix.uz</strong> — надежный сервис для проверки истории автомобилей. Мы помогаем покупателям избежать обмана при покупке подержанных автомобилей, предоставляя информацию о ДТП и повреждениях.",
    "stats": "{{count}} проверенных автомобилей",
    "viewsStats": "{{count}} просмотров",
    "viewsHint": "Суммарные просмотры всех карточек (для рекламодателей)",
    "workingHours": "Работаем 24/7",
    "followTitle": "Следите за нами",
    "followText": "Подписывайтесь на наш Telegram канал для получения актуальных новостей, полезных советов и уведомлений о новых проверках.",
    "subscribeButton": "Подписаться на канал",
    "importantTitle": "⚠️ Важная информация",
    "importantText": "Мы не несем ответственности за достоверность и актуальность представленной информации. Все данные получены из открытых источников в интернете и могут содержать неточности. При принятии решений о покупке автомобиля рекомендуем дополнительно проверять информацию через официальные источники и проводить техническую экспертизу.",
    "copyright": "© 2025 Avto-Tarix.uz | Информационный сервис для проверки истории автомобилей"
  },
  "common": {
    "loading": "Загрузка...",
    "error": "Произошла ошибка",
    "success": "Успешно",
    "cancel": "Отмена",
    "save": "Сохранить",
    "delete": "Удалить",
    "edit": "Редактировать",
    "close": "Закрыть",
    "yes": "Да",
    "no": "Нет",
    "confirm": "Подтвердить"
  }
};

const resources = {
  uz: {
    translation: uzTranslation
  },
  ru: {
    translation: ruTranslation
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'uz', // Узбекский как основной язык
    debug: false,
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false, // React уже экранирует значения
    }
  });

export default i18n;
